export function createProjectSaveTimers({ setTimeoutImpl = globalThis.setTimeout, clearTimeoutImpl = globalThis.clearTimeout } = {}) {
  const timers = new Map();
  return {
    schedule(projectId, callback, delay) {
      if (!projectId) return;
      this.cancel(projectId);
      const timer = setTimeoutImpl(() => {
        timers.delete(projectId);
        callback();
      }, delay);
      timers.set(projectId, timer);
    },
    cancel(projectId) {
      if (!timers.has(projectId)) return;
      clearTimeoutImpl(timers.get(projectId));
      timers.delete(projectId);
    },
    has(projectId) { return timers.has(projectId); }
  };
}
